import { useLingui } from "@lingui/react";
import { useTheme } from "@stylingcv/hooks";
import { cn } from "@stylingcv/utils";

type Props = {
  size?: number;
  className?: string;
};

export const Icon = ({ size = 32, className }: Props) => {
  const { isDarkMode } = useTheme();
  const { i18n } = useLingui();

  // Enhanced Arabic detection - check both app locale and any Arabic locale codes
  const isArabic =
    i18n.locale === "ar-SA" ||
    i18n.locale.startsWith("ar-") ||
    i18n.locale.toLowerCase().includes("arabic");

  let src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

  switch (isDarkMode) {
    case false: {
      src = isArabic ? "/icon/light-ar.svg" : "/icon/dark.svg";
      break;
    }
    case true: {
      src = isArabic ? "/icon/dark-ar.svg" : "/icon/light.svg";
      break;
    }
  }

  return <img src={src} width={size} height={size} alt="Stylion" className={cn("", className)} />;
};
